import type { FaireProductEntity } from "../../entity_types/product";

export const p_3cjpjy8zv6: FaireProductEntity = {
  token: "p_3cjpjy8zv6",
  type: "product",
  name: "winter collection watercolor wall art print",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/94c4b3b1a79e204afd3b3576a574893c9d785bfb601a0ed169bb10800f34e58c.jpeg",
  galleryImageUrls: [],
  priceDollars: 11,
  description:
    'Add a cozy touch to your home with the Winter watercolor print.\n\nDetails: \n\n- 8"x10" print of original watercolor artwork by Emily Lex\n- Printed in full color on thick, superfine paper\n- Packaged in a clear protective sleeve with chipboard backing\n- Frame and mat not included\n',
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:15:08.144Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
